import { jsx as e, Fragment as i } from "react/jsx-runtime";
const p = (t) => {
  const { appMenuItems: a, appNavigator: n } = t;
  return n ? /* @__PURE__ */ e("li", { role: "presentation", children: n }, "app-navigator") : /* @__PURE__ */ e(i, { children: a.map((r) => /* @__PURE__ */ e("li", { role: "presentation", children: r.route }, `link-icon-${r.key}`)) });
};
export {
  p as default
};
//# sourceMappingURL=AppMenuContent.js.map
